module.exports = __webpack_public_path__ + "assets/images/CADUNFIT20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CADUNFIT20.png
// module id = 1333
// module chunks = 1